export default class CF7Forms {
	static init() {
		this.forms = document.querySelectorAll(".wpcf7");

		if (this.forms) {
			this.initInputEvents();
			this.initFormEvents();
		}
	}

	static initFormEvents() {
		this.forms.forEach(wpcf7Form => {
			this.submitEvents(wpcf7Form);
			this.wpcf7FailEvents(wpcf7Form);
			this.wpcf7SuccessEvents(wpcf7Form);
		});
	}

	static initInputEvents() {
		const inputs = document.querySelectorAll(".form-field:not(.type-checkbox):not(.type-radio):not(.type-file) input, .form-field textarea, .form-field select, .form-field-inline input");
		inputs.forEach(input => {
			const inputContainer = input.closest(".form-field, .form-field-inline");

			input.addEventListener("focus", () => {
				inputContainer.classList.add("active");
			});

			input.addEventListener("blur", () => {
				inputContainer.classList.remove("active");

				if (input.value === "") {
					inputContainer.classList.remove("filled");
				} else {
					inputContainer.classList.add("filled");
				}
			});
		});

		const submits = document.querySelectorAll(".form-actions button[type='submit']");
		submits.forEach(submit => {
			submit.insertAdjacentHTML("beforeend",
				`<svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M14.5 1C7.04416 1 1 7.04416 1 14.5C1 21.9558 7.04416 28 14.5 28C21.9558 28 28 21.9558 28 14.5C28 10.8679 26.5657 7.5709 24.2326 5.14437" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
				</svg>`);
		});

		// Managing input files
		const inputsFile = document.querySelectorAll(".form-field.type-file");
		inputsFile.forEach(inputContainer => {
			const input = inputContainer.querySelector(`input[type="file"]`);
			inputContainer.insertAdjacentHTML("beforeend",
				`<span class="close">
					<svg class="closeicon" width="18" height="17" viewBox="0 0 18 17" xmlns="http://www.w3.org/2000/svg">
						<rect x="15.874" y="0.0908203" width="1.65421" height="21.6412" transform="rotate(45 15.874 0.0908203)" fill="currentColor"/>
						<rect x="0.571289" y="1.5481" width="1.65421" height="21.6412" transform="rotate(-45 0.571289 1.5481)" fill="currentColor"/>
					</svg>
				</span>				
				<svg class="fileicon" width="30" height="37" viewBox="0 0 30 37" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M17.8496 29.021L7.24301 18.4144C6.46196 17.6333 5.19563 17.6333 4.41458 18.4144C3.63353 19.1954 3.63353 20.4618 4.41458 21.2428L15.0212 31.8494L17.8496 29.021Z" fill="currentColor"/>
					<path d="M15.0215 31.8491L25.6281 21.2425C26.4091 20.4615 26.4091 19.1951 25.6281 18.4141C24.847 17.633 23.5807 17.633 22.7997 18.4141L12.1931 29.0207L15.0215 31.8491Z" fill="currentColor"/>
					<rect width="30" height="3.75" rx="1.875" transform="matrix(-1 0 0 1 30 33)" fill="currentColor"/>
					<rect width="30" height="3.75" rx="1.875" transform="matrix(-4.37114e-08 1 1 4.37114e-08 13.125 0)" fill="currentColor"/>
				</svg>`
			);

			const label = inputContainer.querySelector("label");
			let labelValue = label.innerHTML;
			label.dataset.labelValue = labelValue;

			input.addEventListener("change", (e) => {
				let fileName = e.target.value.split('\\').pop();

				if (fileName) {
					label.innerHTML = fileName;
					inputContainer.classList.add("filled");
				} else {
					label.innerHTML = labelValue;
					inputContainer.classList.remove("filled");
				}
			});

			inputContainer.querySelector(".close").addEventListener("click", () => {
				label.innerHTML = labelValue;
				input.value = "";
				inputContainer.classList.remove("filled");
			});

			// Firefox bug fix
			input.addEventListener("focus", () => {
				inputContainer.classList.add("active");
				input.classList.add("has-focus");
			});

			input.addEventListener("blur", () => {
				inputContainer.classList.remove("active");
				input.classList.remove("has-focus");
			});
		});
	}

	static submitEvents(form) {
		const submitBtn = form.querySelector(".wpcf7 .form-actions button[type='submit']");

		if (submitBtn) {
			submitBtn.addEventListener("click", () => {
				form.classList.add("loading");
			});
		}
	}

	static wpcf7FailEvents(form) {
		form.addMultipleEventListeners('wpcf7invalid wpcf7spam wpcf7mailfailed wpcf7unaccepted', () => {
			form.classList.remove("loading");
		});
	}

	static wpcf7SuccessEvents(form) {
		form.addEventListener("wpcf7mailsent", () => {
			form.classList.remove("loading");
			form.classList.add("success");
			this.resetForm(form);
		});
	}

	static resetForm(form) {
		const inputs = form.querySelectorAll(".form-field");
		const resetBtn = form.querySelector("input[type='reset']");
		inputs.forEach(input => {
			input.classList.remove("filled");
			if (input.classList.contains("type-file")) {
				const label = input.querySelector("label");
				label.innerHTML = label.dataset.labelValue;
			}
		});

		setTimeout(function () {
			form.classList.remove("success");
			resetBtn.click();
		}, 5000);
	}
}
